mutation AddChannelToEvent($eventId: ID!, $channelLogin: String!) {
  binding: StreamToolsAddChannelToEvent(
    eventId: $eventId
    channelLogin: $channelLogin
  ) {
    eventId
    broadcasterUserId
    channelLogin
    botUserId
    addedAt
    edge
    botAccess
  }
}
